module.exports = __webpack_public_path__ + "img/1440.af7950be.jpg";